import { bhStoreApiRequest } from "@lib/request";
import { Customer } from "@medusajs/medusa";
import { useCallback, useEffect, useState } from "react";

function useCustomerProductGroups(customer?: Omit<Customer, 'password_hash'>) {
  const [loading, setLoading] = useState(false);
  const [productVisibilityGroups, setProductVisibilityGroups] = useState<ProductVisibilityGroup[]>([])

  const getCustomerProductVisibilityGroups = useCallback(async () => {
    if (customer) {
      setLoading(true)
      try {
        // Get customer's product visibility groups
        const { data } = await bhStoreApiRequest<ProductVisibilityGroup[]>(`/customers/product-visibility-groups`)
        setProductVisibilityGroups(data)
      } catch (error) {
        console.error("Failed to fetch product visibility groups", error)
        setProductVisibilityGroups([])
      } finally {
        setLoading(false)
      }
    } else {
      setProductVisibilityGroups([])
    }
  }, [customer])

  useEffect(() => {
    getCustomerProductVisibilityGroups()
  }, [getCustomerProductVisibilityGroups])

  return {
    productVisibilityGroups,
    loading
  }
}

export default useCustomerProductGroups